<template>
  <div class="page-view">
    <div class="header-row">
      <div>
        <h2>数据看板</h2>
        <p>按当前账号及其可见范围展示订单概况。</p>
      </div>
      <el-button type="primary" plain @click="loadData">刷新</el-button>
    </div>

    <el-row :gutter="18">
      <el-col v-for="item in cards" :key="item.key" :span="8">
        <div class="metric-card">
          <span>{{ item.label }}</span>
          <strong>{{ overview[item.key] || 0 }}</strong>
        </div>
      </el-col>
    </el-row>

    <div class="section-block">
      <div class="section-head">
        <h3>本月完成 - 业务员维度</h3>
      </div>
      <el-table :data="detail.sales_completed_stats" stripe>
        <el-table-column prop="label" label="业务员" min-width="180" />
        <el-table-column prop="count" label="完成单数" width="120" />
        <el-table-column label="占比" min-width="240">
          <template slot-scope="{ row }">
            <div class="bar-row">
              <div class="bar-track">
                <div class="bar-fill" :style="{ width: salesPercent(row.count) + '%' }"></div>
              </div>
              <span>{{ salesPercent(row.count) }}%</span>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div class="section-block">
      <div class="section-head">
        <h3>本月完成 - 配送员维度</h3>
      </div>
      <el-table :data="detail.courier_completed_stats" stripe>
        <el-table-column prop="label" label="配送员" min-width="180" />
        <el-table-column prop="count" label="完成单数" width="120" />
        <el-table-column label="占比" min-width="240">
          <template slot-scope="{ row }">
            <div class="bar-row">
              <div class="bar-track">
                <div class="bar-fill" :style="{ width: courierPercent(row.count) + '%' }"></div>
              </div>
              <span>{{ courierPercent(row.count) }}%</span>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div class="section-block">
      <div class="section-head">
        <h3>城市维度</h3>
      </div>
      <el-table :data="detail.city_stats" stripe>
        <el-table-column prop="label" label="城市" min-width="180" />
        <el-table-column prop="count" label="订单数" width="120" />
        <el-table-column label="占比" min-width="240">
          <template slot-scope="{ row }">
            <div class="bar-row">
              <div class="bar-track">
                <div class="bar-fill" :style="{ width: cityPercent(row.count) + '%' }"></div>
              </div>
              <span>{{ cityPercent(row.count) }}%</span>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div class="section-block">
      <div class="section-head">
        <h3>供应商维度</h3>
      </div>
      <el-table :data="detail.supplier_stats" stripe>
        <el-table-column prop="label" label="供应商" min-width="180" />
        <el-table-column prop="count" label="订单数" width="120" />
        <el-table-column label="占比" min-width="240">
          <template slot-scope="{ row }">
            <div class="bar-row">
              <div class="bar-track">
                <div class="bar-fill" :style="{ width: supplierPercent(row.count) + '%' }"></div>
              </div>
              <span>{{ supplierPercent(row.count) }}%</span>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div class="section-block">
      <div class="section-head">
        <h3>近 7 天趋势</h3>
      </div>
      <div class="trend-list">
        <div v-for="item in detail.trend" :key="item.date" class="trend-row">
          <span class="trend-date">{{ item.date }}</span>
          <div class="trend-bar">
            <div class="trend-fill" :style="{ width: trendPercent(item.count) + '%' }"></div>
          </div>
          <span class="trend-count">{{ item.count }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { fetchDashboard, fetchDashboardDetails } from "../api/orders";

export default {
  data() {
    return {
      overview: {},
      detail: {
        city_stats: [],
        supplier_stats: [],
        sales_completed_stats: [],
        courier_completed_stats: [],
        trend: [],
      },
      cards: [
        { key: "today_new", label: "今日新单" },
        { key: "wait_assign", label: "待分配" },
        { key: "in_delivery", label: "配送中" },
        { key: "pending_review", label: "待审核" },
        { key: "today_completed", label: "今日完成" },
        { key: "month_completed", label: "本月完成" },
      ],
    };
  },
  mounted() {
    this.loadData();
  },
  methods: {
    async loadData() {
      const [{ data: overview }, { data: detail }] = await Promise.all([fetchDashboard(), fetchDashboardDetails()]);
      this.overview = overview || {};
      this.detail = {
        city_stats: detail.city_stats || [],
        supplier_stats: detail.supplier_stats || [],
        sales_completed_stats: detail.sales_completed_stats || [],
        courier_completed_stats: detail.courier_completed_stats || [],
        trend: detail.trend || [],
      };
    },
    cityPercent(count) {
      return this.percent(count, this.detail.city_stats);
    },
    supplierPercent(count) {
      return this.percent(count, this.detail.supplier_stats);
    },
    salesPercent(count) {
      return this.percent(count, this.detail.sales_completed_stats);
    },
    courierPercent(count) {
      return this.percent(count, this.detail.courier_completed_stats);
    },
    trendPercent(count) {
      const max = Math.max(...this.detail.trend.map((item) => item.count), 1);
      return Math.round((count / max) * 100);
    },
    percent(count, list) {
      const total = list.reduce((sum, item) => sum + (item.count || 0), 0) || 1;
      return Math.round((count / total) * 100);
    },
  },
};
</script>

<style scoped>
.header-row { display: flex; justify-content: space-between; align-items: center; margin-bottom: 20px; }
.header-row h2 { margin: 0 0 8px; }
.header-row p { margin: 0; color: #60718f; }
.el-col { margin-bottom: 18px; }
.section-block { margin-top: 24px; }
.section-head { display: flex; justify-content: space-between; align-items: center; margin-bottom: 14px; }
.section-head h3 { margin: 0; }
.bar-row { display: flex; align-items: center; gap: 12px; }
.bar-track {
  flex: 1;
  height: 10px;
  border-radius: 999px;
  background: #e6eefc;
  overflow: hidden;
}
.bar-fill {
  height: 100%;
  border-radius: inherit;
  background: linear-gradient(90deg, #2f76ff 0%, #5ea0ff 100%);
}
.trend-list {
  display: grid;
  gap: 12px;
  padding: 16px;
  border-radius: 14px;
  background: #fff;
  border: 1px solid #e8eefb;
}
.trend-row {
  display: grid;
  grid-template-columns: 110px 1fr 50px;
  gap: 12px;
  align-items: center;
}
.trend-date { color: #60718f; font-size: 13px; }
.trend-bar {
  height: 12px;
  border-radius: 999px;
  background: #e6eefc;
  overflow: hidden;
}
.trend-fill {
  height: 100%;
  border-radius: inherit;
  background: linear-gradient(90deg, #173c89 0%, #2f76ff 100%);
}
.trend-count { text-align: right; color: #1d2b53; font-weight: 600; }
</style>
